import './error-state/error-state.component'

function DomainDetailsCtrl($log,
                           $stateParams,
                           DomainsService,
                           $state,
                           sweet,
                           ProgressBarService,
                           ToastsService,
                           SessionsService) {
  "ngInject";

  let vm = this;
  vm.currentDomain = {
    key: undefined,
    name: undefined,
    impersonationAdminEmailAddress: undefined,
    distributor_key: undefined,
    organizationUnitPath: '/skykit',
    active: true
  };
  vm.devicesAccess = false;
  vm.orgUnitsAccess = false;
  vm.usersAccess = false;
  vm.currentDomains = [];
  vm.editMode = !!$stateParams.domainId;
  vm.isTenant = SessionsService.getIsTenant();

  if (vm.editMode) {
    let domainPromise = DomainsService.getDomainById($stateParams.domainId);
    domainPromise.then(data => {
      vm.currentDomain = data
    });
  } else {
    vm.currentDomain.distributor_key = SessionsService.getCurrentDistributorKey();
  }

  vm.initialize = async ()  => {
    if (vm.editMode) {
      try {
        ProgressBarService.start();
        let connectivityPromise = await DomainsService.getDirectoryApiConnectivityInformation($stateParams.domainId);
        vm.onSuccessDeterminingConnectivity(connectivityPromise)
      } catch (e) {
        vm.onFailureDeterminingConnectivity()
      }
    }
  };

  vm.onSuccessDeterminingConnectivity = function (data) {
    vm.devicesAccess = data.devicesAccess;
    vm.orgUnitsAccess = data.orgUnitsAccess;
    vm.usersAccess = data.usersAccess;
    vm.devicesAccessException = data.devicesAccessException;
    vm.orgUnitsAccessException = data.orgUnitsAccessException;
    vm.usersAccessException = data.usersAccessException;
    ProgressBarService.complete();
  };

  vm.onFailureDeterminingConnectivity = function (error) {
    ProgressBarService.complete();
    $log.error(`Failure determining directory API connectivity: ${error.status } ${error.statusText}`);
    return ToastsService.showErrorToast('Oops. We were unable determine your device connectivity at this time.');
  };

  vm.onSaveDomain = function () {
    ProgressBarService.start();
    let promise = DomainsService.save(vm.currentDomain);
    return promise.then(vm.onSuccessSaveDomain, vm.onFailureSaveDomain);
  };

  vm.onSuccessSaveDomain = function () {
    ProgressBarService.complete();
    return ToastsService.showSuccessToast('We saved your update.');
  };

  vm.onFailureSaveDomain = function (error) {
    ProgressBarService.complete();
    if (error.status === 409) {
      $log.info(`Failure saving domain. Domain already exists: ${error.status} ${error.statusText}`);
      return sweet.show('Oops...', 'This domain name already exist. Please enter a unique domain name.', 'error');
    } else {
      $log.error(`Failure saving domain: ${error.status } ${error.statusText}`);
      return ToastsService.showErrorToast('Oops. We were unable to save your updates at this time.');
    }
  };

  vm.editItem = item => $state.go('main.editDomain', {domainId: item.id});

  return vm;
}

export {DomainDetailsCtrl}
